var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 648.17 648.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,81.75v484.68c0,45.75,36,81.75,81.75,81.75h484.68c22.39,0,43.79-10.71,57.43-24.32,14.61-14.61,24.32-33.1,24.32-57.43V81.75c0-45.75-36-81.75-81.75-81.75H81.75c-24.32,0-42.82,9.75-57.43,24.32C10.68,37.96,0,59.36,0,81.75ZM87.6,145.97c0-31.14,25.32-58.39,56.46-58.39s58.39,27.25,58.39,58.39-26.28,57.43-58.39,57.43-56.46-25.32-56.46-57.43ZM244.28,545.96V249.14c0-6.82,6.82-12.64,11.68-12.64h82.72c11.68,0,11.68,13.64,11.68,22.39,23.36-23.36,53.53-29.21,84.68-29.21,75.93,0,124.57,36,124.57,115.82v200.5c0,6.82-5.85,12.64-11.68,12.64h-85.64c-6.82,0-11.68-6.82-11.68-12.64v-181.03c0-30.18-8.75-46.71-42.82-46.71-42.82,0-53.53,28.22-53.53,66.18v161.57c0,6.82-6.82,12.64-13.64,12.64h-84.68c-4.86,0-11.68-6.82-11.68-12.64l.03-.03ZM89.54,545.96V249.14c0-6.82,6.82-12.64,11.68-12.64h84.68c7.79,0,12.64,4.86,12.64,12.64v296.82c0,6.82-5.85,12.64-12.64,12.64h-84.68c-5.85,0-11.68-6.82-11.68-12.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f1abce267cc7dba4dd69eabb47d11e17.svg";
export { ForwardRef as ReactComponent };